import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, withCredentials: true });

// Public
export const fetchProjects = (params = {}) => api.get('/projects', { params }).then((r) => r.data);
export const fetchProject = (id) => api.get(`/projects/${id}`).then((r) => r.data);
export const fetchDevelopers = () => api.get('/developers').then((r) => r.data);
export const createDeveloper = (data) => api.post('/developers', data).then((r) => r.data);
export const updateDeveloper = (id, data) => api.put(`/developers/${id}`, data).then((r) => r.data);
export const deleteDeveloper = (id) => api.delete(`/developers/${id}`).then((r) => r.data);
export const fetchAreas = () => api.get('/areas').then((r) => r.data);
export const fetchSettings = () => api.get('/settings').then((r) => r.data);
export const fetchAgents = () => api.get('/agents').then((r) => r.data);
export const fetchRates = () => api.get('/currency/rates').then((r) => r.data);
export const submitLead = (payload) => api.post('/leads', payload).then((r) => r.data);
export const translateTexts = (texts, target) => api.post('/translate', { texts, target }).then((r) => r.data.translations);

// Admin
export const adminLogin = (email, password) => api.post('/auth/login', { email, password }).then((r) => r.data);
export const adminLogout = () => api.post('/auth/logout').then((r) => r.data);
export const adminMe = () => api.get('/auth/me').then((r) => r.data);
export const createProject = (p) => api.post('/projects', p).then((r) => r.data);
export const updateProject = (id, p) => api.put(`/projects/${id}`, p).then((r) => r.data);
export const deleteProject = (id) => api.delete(`/projects/${id}`).then((r) => r.data);
export const fetchLeads = () => api.get('/leads').then((r) => r.data);
export const deleteLead = (id) => api.delete(`/leads/${id}`).then((r) => r.data);
export const updateLeadStatus = (id, status) => api.patch(`/leads/${id}/status`, { status }).then((r) => r.data);
export const addLeadNote = (id, text) => api.post(`/leads/${id}/notes`, { text }).then((r) => r.data);
export const assignLeadOwner = (id, ownerId) => api.patch(`/leads/${id}/owner`, { ownerId }).then((r) => r.data);
export const createAgent = (a) => api.post('/agents', a).then((r) => r.data);
export const updateAgent = (id, a) => api.put(`/agents/${id}`, a).then((r) => r.data);
export const deleteAgent = (id) => api.delete(`/agents/${id}`).then((r) => r.data);
export const updateSettings = (s) => api.put('/settings', s).then((r) => r.data);
export const fetchUsers = () => api.get('/users').then((r) => r.data);
export const createUser = (u) => api.post('/users', u).then((r) => r.data);
export const updateUser = (email, u) => api.put(`/users/${encodeURIComponent(email)}`, u).then((r) => r.data);
export const deleteUser = (email) => api.delete(`/users/${encodeURIComponent(email)}`).then((r) => r.data);

// File & media storage
export const uploadFile = (file, onProgress) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post('/upload', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => { if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100)); },
  }).then((r) => r.data);
};

export const exportLeads = (params = {}) => api.get('/leads/export', { params, responseType: 'blob' }).then((r) => r.data);
export const fetchCrmInfo = () => api.get('/crm/info').then((r) => r.data);
export const rotateCrmKey = () => api.post('/crm/rotate-key').then((r) => r.data);
